import Service from 'react-reservice';

import { ESymbolCategory, ISymbolDetail } from '@aqx-core/common/api/market';

import { EChartProvider } from './equity-chart';
import { ISymbolDetailData } from './types';

export interface ITradeAnalysisServiceContext {
  symbolDetailLoading?: boolean;
  symbolDetail?: Partial<ISymbolDetail>;
  symbolDetailId?: string;
  editingSymbolDetail?: Partial<ISymbolDetail>;
  editingSymbolDetailLoading?: boolean;
  tradingTab: ESymbolCategory | undefined;
  lastSelectedChartProvider?: EChartProvider;
}

const defaultContext: ITradeAnalysisServiceContext = {
  symbolDetailLoading: true,
  tradingTab: ESymbolCategory.EQUITIES
};

class TradeAnalysisService extends Service<ITradeAnalysisServiceContext> {
  constructor() {
    super();

    this.context = defaultContext;
  }

  setSymbolDetailLoading = (nextLoading: boolean) => {
    this.context.symbolDetailLoading = nextLoading;
  };

  setSymbolDetailId = (nextSymbolId?: string) => {
    this.context.symbolDetailId = nextSymbolId;
  };

  setSymbolDetail = (nextSymbolDetail: Partial<ISymbolDetailData> | undefined) => {
    this.context.symbolDetail = nextSymbolDetail;
  };

  setEditingSymbolDetail = (nextEditingSymbolDetail: Partial<ISymbolDetailData> | undefined) => {
    this.context.editingSymbolDetail = nextEditingSymbolDetail;
  };

  setEditingSymbolDetailLoading = (nextLoading: boolean) => {
    this.context.editingSymbolDetailLoading = nextLoading;
  };

  setTradingTab = (tab: ESymbolCategory | undefined) => {
    this.context.tradingTab = tab;
  };

  setLastSelectedChartProvider = (provider: EChartProvider) => {
    this.context.lastSelectedChartProvider = provider;
  };

  getLastSelectedChartProvider = () => {
    return this.context.lastSelectedChartProvider;
  };

  // Use for unit testing only
  resetContext = () => {
    this.context = { ...defaultContext };
  };
}

export const tradeAnalysisService = new TradeAnalysisService();
